import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';
import * as antd from 'antd';
import RecommendListStore from '@/stores/RecommendListStore';

class ShopCollectStore {
    SortField = {
        CURRENT_PRICE: 'currentPrice',
        SOLD_NUM: 'soldNum'
    };
    Order = {
        ASC: 'asc',
        DESC: 'desc'
    };
    list = [];
    pageSize = 1000;
    pageNum = 1;
    order = undefined;
    sortField = undefined;
    recommendListStore = new RecommendListStore();

    constructor() {
        makeAutoObservable(this)
    }

    async fetchRecommendList() {
        this.recommendListStore.fetchList();
    }

    async fetchList() {
        try {
            const {pageSize, pageNum, order, sortField} = this;

            const {list} = await Api.shopCollectList({
                pageSize,
                pageNum,
                order,
                sortField
            });

            this.list = list;
        } catch (error) {
        }
    }

    /**
     * 删除
     * @param {*} id
     */
    async doDelete(id) {
        try {
            await Api.cancelCollect({
                collectId: id
            });
            antd.message.success('删除成功!');

            await this.fetchList();
        } catch (error) {
        }
    }
}

const store = new ShopCollectStore();

export default store;
